import { MdHomeFilled } from "react-icons/md";
import { DefaultLayout } from "../../layouts";
import { ConstructionLoanScreen, TitleSection } from "../../components";

export default function ConstructionLoan() {
  const breadCrumbs = [
    { title: <MdHomeFilled />, link: "/" },
    { title: "Services", link: "#" },
    { title: "Construction Loan", link: "#" },
  ];

  return (
    <DefaultLayout>
      <TitleSection
        title="Services"
        bg="/images/construction-loan-bg.png"
        breadCrumbs={breadCrumbs}
      />
      <ConstructionLoanScreen />
    </DefaultLayout>
  );
}
